<template>
  <div class="detail-item">
    <div class="row">
      <div class="col-12 col-md">
        <h3
          v-if="content.pv_infoblock_installation_title"
          v-dynamic-content:pv_infoblock_installation_title
        ></h3>
        <p
          v-if="content.pv_infoblock_installation_text"
          v-dynamic-content:pv_infoblock_installation_text
        ></p>
        <ul class="list-check list-unstyled text-left mb-7">
          <li
            v-for="item in installationListItems"
            v-dynamic-content="{ rawText: item }"
            :key="item"
          ></li>
        </ul>
        <div class="mb-7 px-4" v-if="!isBrussels">
          <steps-icons />
        </div>

        <h3
          v-if="content.pv_infoblock_monitoring_title"
          v-dynamic-content:pv_infoblock_monitoring_title
        ></h3>
        <p
          v-if="content.pv_infoblock_monitoring_text && quote.hasSunsure"
          v-dynamic-content:pv_infoblock_monitoring_text
        ></p>
        <p
          v-else-if="content.pv_infoblock_monitoring_text_no_sunsure"
          v-dynamic-content:pv_infoblock_monitoring_text_no_sunsure
        ></p>

        <p
          class="font-weight-bold"
          v-if="content.pv_infoblock_monitoring_list1_title"
          v-dynamic-content:pv_infoblock_monitoring_list1_title
        ></p>
        <ul class="mb-7">
          <li
            v-if="content.pv_infoblock_monitoring_list1_item1 && quote.hasSunsure"
            v-dynamic-content:pv_infoblock_monitoring_list1_item1
          ></li>
          <li
            v-if="content.pv_infoblock_monitoring_list1_item2 && quote.hasSunsure"
            v-dynamic-content:pv_infoblock_monitoring_list1_item2
          ></li>
          <li
            v-if="content.pv_infoblock_monitoring_list1_item3"
            v-dynamic-content:pv_infoblock_monitoring_list1_item3
          ></li>
        </ul>

        <p
          v-if="content.pv_infoblock_monitoring_text2"
          v-dynamic-content:pv_infoblock_monitoring_text2
        ></p>

        <img
          v-if="content.pv_infoblock_monitoring_icon_phone"
          class="mb-7"
          style="width: 172px"
          src="@/assets/icons/monitoring-phone.svg"
        />

        <p
          class="font-size-sm text-muted"
          v-if="content.pv_infoblock_monitoring_subtext"
          v-dynamic-content:pv_infoblock_monitoring_subtext
        ></p>
        <img
          v-if="
            content.pv_infoblock_monitoring_image_toggle &&
            content.pv_infoblock_monitoring_image_toggle !== 'OFF'
          "
          class="mb-7"
          style="max-width: 100%"
          src="@/assets/images/monitoring-portal-image.png"
        />

        <h3
          v-if="content.pv_infoblock_monitoring_subtitle_active_monitoring"
          v-dynamic-content:pv_infoblock_monitoring_subtitle_active_monitoring
        ></h3>
        <p
          v-if="content.pv_infoblock_monitoring_text_active_monitoring"
          v-dynamic-content:pv_infoblock_monitoring_text_active_monitoring
        ></p>
      </div>
    </div>
  </div>
</template>

<script>
import StepsIcons from '@/components/parts/StepsIcons'

export default {
  name: 'DetailInstallationMonitoring',
  props: {
    quote: {
      type: Object,
      required: true,
    },
  },
  components: {
    StepsIcons,
  },
  computed: {
    isBrussels() {
      return this.$store.getters.iquote.configurationId.includes('BRUSSELS')
    },
  },
}
</script>
